
<div class="filterButton px-3 py-2 mb-1 me-1 typo_8"
    [ngClass]="{'bg-color-yellow': color === 0, 'bg-color-blue': color === 1, 'bg-color-green': color === 2, 'isSelected': isSelected, 'useCross': useCross}">
    {{ name }}
</div>
